var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideocreation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.486,
    height: 24.486,
    viewBox: "0 0 24.486 24.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.976,24.486H.51a.511.511,0,0,1-.51-.51V.51A.511.511,0,0,1,.51,0H23.976a.512.512,0,0,1,.51.51V23.976A.512.512,0,0,1,23.976,24.486ZM1.02,23.466H23.466V1.02H1.02Z",
    fill: "#0080ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.956,77.02H2.51a.51.51,0,1,1,0-1.02H24.956a.51.51,0,1,1,0,1.02Z",
    transform: "translate(-1.49 -56.615)",
    fill: "#0080ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.956,17.02H2.51a.51.51,0,0,1,0-1.02H24.956a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-1.49 -11.919)",
    fill: "#0080ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53,85.02H6.51a.51.51,0,0,1,0-1.02H7.53a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-4.47 -62.574)",
    fill: "#0080ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.53,85.02H18.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-13.409 -62.574)",
    fill: "#0080ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.53,85.02H30.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-22.348 -62.574)",
    fill: "#0080ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.53,85.02H42.51a.51.51,0,1,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-31.287 -62.574)",
    fill: "#0080ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.53,85.02H54.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-40.226 -62.574)",
    fill: "#0080ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.53,85.02H66.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-49.166 -62.574)",
    fill: "#0080ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.53,85.02H78.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-58.105 -62.574)",
    fill: "#0080ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53,9.02H6.51A.51.51,0,0,1,6.51,8H7.53a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-4.47 -5.959)",
    fill: "#0080ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.53,9.02H18.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-13.409 -5.959)",
    fill: "#0080ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.53,9.02H30.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-22.348 -5.959)",
    fill: "#0080ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.53,9.02H42.51a.51.51,0,1,1,0-1.02h1.02a.51.51,0,1,1,0,1.02Z",
    transform: "translate(-31.287 -5.959)",
    fill: "#0080ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.53,9.02H54.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-40.226 -5.959)",
    fill: "#0080ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.53,9.02H66.51a.51.51,0,1,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-49.166 -5.959)",
    fill: "#0080ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.53,9.02H78.51a.51.51,0,0,1,0-1.02h1.02a.51.51,0,0,1,0,1.02Z",
    transform: "translate(-58.105 -5.959)",
    fill: "#0080ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.51,37.973a.5.5,0,0,1-.242-.062A.505.505,0,0,1,32,37.463V28.038a.511.511,0,0,1,.791-.424l7.142,4.713a.509.509,0,0,1,0,.851L32.791,37.89A.507.507,0,0,1,32.51,37.973Zm.51-8.986v7.531l5.705-3.764L33.02,28.987Z",
    transform: "translate(-23.838 -20.507)",
    fill: "#0080ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocreation);
export default __webpack_public_path__ + "static/media/videocreation.14becfb3.svg";
export { ForwardRef as ReactComponent };